module.exports = __webpack_public_path__ + "img/regular-exercise-no.23b56acb.svg";